// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wLAY5Yekjh024uVknTem{height:51px}.OyMgVzyD3vQUIC2RI3et{align-items:center;display:flex}.UZheduWk1BwIatS31Xo2{flex-direction:column;gap:4px;padding:8px 12px;display:flex}.VkWhoJcfxCYMFJTfnWbT{background:var(--black-10)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"option": `wLAY5Yekjh024uVknTem`,
	"optionWrap": `OyMgVzyD3vQUIC2RI3et`,
	"optionWrap__info": `UZheduWk1BwIatS31Xo2`,
	"optionWrapInfo": `UZheduWk1BwIatS31Xo2`,
	"optionWrap__icon": `VkWhoJcfxCYMFJTfnWbT`,
	"optionWrapIcon": `VkWhoJcfxCYMFJTfnWbT`
};
export default ___CSS_LOADER_EXPORT___;
